import React, {
  HTMLAttributes,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import { useStore } from "../../store";

import PasskeyVerify from "../../Verify";
import ListFaType2 from "../../ListFaType2";
import ItemInput from "../../ItemInput";

import styles from "./index.module.scss";

import {
  FaCheckItemProps,
  ModalTitleProps,
} from "../../Modal";
import { VerifyTypeEnum } from "../../ItemButton";

// const { useTranslation } = Hooks;

export enum ModeEnum {
  list = "list", //列表选择页
  listPasskey = "listPasskey", //通行密钥验证页面
}

type ModeType = ModeEnum | VerifyTypeEnum;

interface Props extends HTMLAttributes<HTMLDivElement> {
  faBizType: number;
  dynamicCodeType: string;
  faCheckItemData: FaCheckItemProps;
  successCallback: (arg?: any) => void;
  setDisabled: (arg: boolean) => void;
  setModalTitle: (arg: ModalTitleProps | undefined) => void;
  msgSendDataObj?: any;
}

const Main: React.FC<Props> = ({
  faBizType,
  dynamicCodeType,
  faCheckItemData,
  successCallback,
  setDisabled,
  setModalTitle,
  msgSendDataObj,
  className,
}) => {
  // const t = useTranslation();
  const { isPasskeySupport: appIsPasskeySupport } = useStore();

  const [mode, setMode] = useState<ModeType>();
  useEffect(() => {
    if (
      mode &&
      Object.values(VerifyTypeEnum).includes(mode as VerifyTypeEnum)
    ) {
      setModalTitle({
        onClick: () =>
          setMode(
            mode === VerifyTypeEnum.passkey
              ? ModeEnum.listPasskey
              : ModeEnum.list
          ),
      });
    } else {
      setModalTitle(undefined);
    }
  }, [mode]);

  const [completeTypeAry, setCompleteTypeAry] = useState<VerifyTypeEnum[]>([]);

  const isPasskeySupport = useMemo(() => {
    if (faCheckItemData && faCheckItemData.passkeyEnable && appIsPasskeySupport)
      return true;
    return false;
  }, [faCheckItemData, appIsPasskeySupport]);

  useEffect(() => {
    if (isPasskeySupport) setMode(ModeEnum.listPasskey);
    else setMode(ModeEnum.list);
  }, []);

  const isFaResult = useMemo(() => {
    return completeTypeAry.length + 1 >= faCheckItemData.faItems.length;
  }, [completeTypeAry, faCheckItemData]);
  const handleItemInputSuccess = useCallback(
    async (data) => {
      if (!isFaResult) {
        !completeTypeAry.includes(mode as VerifyTypeEnum) &&
          setCompleteTypeAry([...completeTypeAry, mode as VerifyTypeEnum]);
        setMode(ModeEnum.list);
      } else {
        await successCallback(data);
      }
    },
    [mode, completeTypeAry, isFaResult, successCallback]
  );

  const itemInputProps = {
    faBizType,
    dynamicCodeType,
    faCheckItemData,
    isFaResult,
    successCallback: handleItemInputSuccess,
    setDisabled,
    msgSendDataObj,
  };

  return (
    <div className={cx(styles.main, className)}>
      {(mode === ModeEnum.list || mode === ModeEnum.listPasskey) && (
        <ListFaType2
          mode={mode}
          completeTypeAry={completeTypeAry}
          isPasskey={isPasskeySupport}
          faItems={faCheckItemData.faItems}
          clickFun={setMode}
        />
      )}

      {mode === VerifyTypeEnum.passkey && (
        <PasskeyVerify
          faBizType={faBizType}
          faCheckId={faCheckItemData.faCheckId}
          successCallback={successCallback}
          updateLoading={setDisabled}
          // onSwitch={() => setMode(ModeEnum.list)}
        />
      )}
      {mode === VerifyTypeEnum.email && (
        <ItemInput type={VerifyTypeEnum.email} {...itemInputProps} />
      )}
      {mode === VerifyTypeEnum.mobile && (
        <ItemInput type={VerifyTypeEnum.mobile} {...itemInputProps} />
      )}
      {mode === VerifyTypeEnum.google && (
        <ItemInput type={VerifyTypeEnum.google} {...itemInputProps} />
      )}
    </div>
  );
};

export default Main;
